<template>
<v-container>
  <v-card class="pa-3">
    <!-- Las dos rutas comparten esta vista: la key rehace la tabla al pasar
         de una a otra. -->
    <TablaEmpresas
      :key="admin ? 'admin' : 'alumno'"
      :endpointEmpresas="admin ? 'empresas_admin' : 'empresas'"
      :endpointSucursales="admin ? 'sucursales_admin' : null"
      :rutaDetalle="admin ? '/admin_empresas/' : '/empresas/'"
    ></TablaEmpresas>
  </v-card>
  </v-container>
</template>

<script>
import TablaEmpresas from '@/components/empresas/TablaEmpresas.vue'

// La lista de empresas, para alumnos (/empresas) y para el administrador
// (/admin_empresas, con `admin`), que además puede listar sucursales.
export default {
  components: { TablaEmpresas },
  props: {
    admin: { type: Boolean, default: false },
  },
};
</script>

<style></style>
